import { useEffect } from "react";
import eruda from "eruda";

const useEruda = () => {
  useEffect(() => {
    if (import.meta.env.VITE_DEBUG === "true") {
      try {
        const erudaEl = document.createElement("div");
        erudaEl.id = "eruda";
        document.body.appendChild(erudaEl);
        eruda.init({
          container: erudaEl,
          tool: ["console", "elements"],
          useShadowDom: false,
          defaults: {
            displaySize: 50,
            transparency: 0.9,
            theme: "Monokai Pro",
          },
        });
        eruda.position({ x: window.innerWidth - 50, y: 20 });
      } catch (error) {
        console.error("ERUDA ERROR");
        console.error(error);
      }
    }
  }, []);
};

export { useEruda };
